<template>
  <div>
    <Toast />
    <Toast position="top-right" group="tr">
      <template #message="slotProps">
        <div class="flex flex-col items-start flex-auto">
          <div class="font-medium text-lg my-4 toast-summary">
            {{ slotProps.message.summary }}
          </div>
          <div class="font-medium text-lg my-4">
            {{ slotProps.message.detail.descNotificacao }}
          </div>
          <Button
            style="margin-top: 1rem"
            size="small"
            label="Ciente"
            severity="success"
            @click="cienteOnClick(slotProps.message.detail)"
          />
        </div>
      </template>
    </Toast>
    <Loader :isVisible.sync="loaderTrue" :text="'Carregando'" />

    <Login
      v-if="
        !isUserLogado &&
        this.$route.name &&
        this.$route.name.split('-').length > 0 &&
        this.$route.name.split('-')[1] != 'publico'
      "
    />

    <div
      v-else-if="
        this.$route.name &&
        this.$route.name.split('-').length > 0 &&
        this.$route.name.split('-')[1] == 'publico'
      "
    >
      <router-view />
    </div>

    <div v-else :class="containerClass" @click="onWrapperClick">
      <AppTopBar @menu-toggle="onMenuToggle" />
      <div class="layout-sidebar layout-sidebar-light" @click="onSidebarClick">
        <div class="layout-logo">
          <router-link to="/portalservidor">
            <img
              alt="seplag"
              src="./assets/LOGO SEPLAG - BRANCO VAZADO.svg"
              style="width: 60%"
            />
          </router-link>
        </div>
        <AppProfile
          :ontrocarSenha="trocarSenha"
          :ontrocarVinculo="trocarVinculo"
          :podeDadosPessoais="podeDadosPessoais"
        />
        <AppMenu :model.sync="menu" @menuitem-click="onMenuItemClick" />
        <div class="versionamentoSistema">
          Versão {{ versaoFRONT }} - {{ versaoAPI }}
        </div>
      </div>

      <div class="layout-main" v-if="isExisteUser">
        <router-view />

        <cadastro-rapido
          tituloTela="Trocar a Senha"
          v-model="exibirTelaTrocarSenha"
          :modoEdicao="modoEdicao"
          :onEnviarLinkAtivacao="atualizarSenha"
          :visivelFechar="visivelFecharTela"
          v-if="exibirTelaTrocarSenha"
          :textoButton="'Alterar'"
        >
          <Rotulo nome="Senha Atual" cols="12">
            <InputText
              type="password"
              v-model="registroLogin.senhaAtual"
              v-required
            />
          </Rotulo>
          <Rotulo nome="Nova Senha" cols="12">
            <InputText
              type="password"
              v-model="registroLogin.senhaNova"
              v-required
            />
          </Rotulo>
          <Rotulo nome="Confirma Nova Senha" cols="12">
            <InputText
              type="password"
              v-model="registroLogin.confirmarSenha"
              v-required
            />
          </Rotulo>
        </cadastro-rapido>

        <cadastro-rapido
          tituloTela="Trocar Vinculo"
          v-model="exibirTelaTrocaVinculo"
          :modoEdicao="'alterar'"
          :tamanhoTela="'100em'"
          :onAlterar="atualizarVinculo"
          :visivelFechar="visivelFecharTela"
          v-if="exibirTelaTrocaVinculo"
          :textoButton="'Alterar'"
        >
          <Rotulo nome="Selecione o Novo Vinculo" cols="12">
            <DataTable
              :value="vinculos"
              :selection.sync="registroVinculo"
              dataKey="idenVinculo"
            >
              <Column selectionMode="single" headerStyle="width: 3em"></Column>
              <Column
                field="numrMatricula"
                header="Matrícula"
                :bodyStyle="'text-align: center'"
                :headerStyle="'width: 6em;'"
              >
                <template #body="slotProps">
                  {{
                    slotProps.data.vinculoServidor != null
                      ? slotProps.data.vinculoServidor.numrMatricula
                      : slotProps.data.numrMatricula
                  }}
                </template>
              </Column>
              <Column
                field="numrVinculo"
                header="Vínculo"
                :bodyStyle="'text-align: center'"
                :headerStyle="'width: 6em;'"
              >
              </Column>
              <Column
                field="numrPensionista"
                header="Numero Pensionista"
                :bodyStyle="'text-align: center'"
                :headerStyle="'width: 6em;'"
              ></Column>
              <Column
                field="tipoVinculo.descTipoVinculo"
                header="Vinculo"
                :bodyStyle="'text-align: center'"
                :headerStyle="'width: 6em;'"
              ></Column>
              <Column
                field="statVinculo"
                header="Situação"
                :bodyStyle="'text-align: center'"
                :headerStyle="'width:10em;'"
              >
              </Column>
              <Column
                field="unidade.descUnidade"
                header="Setor"
                :bodyStyle="'text-align: center'"
              ></Column>
              <Column field="orgao.descOrgao" header="Órgão"></Column>
            </DataTable>
          </Rotulo>
        </cadastro-rapido>
      </div>
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppTopBar from "./AppTopbar.vue";
import AppProfile from "./AppProfile.vue";
import AppMenu from "./AppMenu.vue";
import AppFooter from "./AppFooter.vue";
import Login from "./paginas/login/Login.vue";
import { mapGetters } from "vuex";
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import Loader from "@/paginas/Loader.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import {
  baseApiUrl,
  baseApiUrlCracha,
  isUserTemPerssaoGlobal,
} from "@/config/global";

const getDefaultState = () => {
  return {
    id: "",
    login: "",
    senhaAtual: "",
    senhaNova: "",
    confirmarSenha: "",
  };
};

export default {
  data() {
    return {
      layoutMode: "static",
      layoutColorMode: "dark",
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      exibirTelaTrocarSenha: false,
      exibirTelaTrocaVinculo: false,
      exibirTelaTrocaPensao: false,
      visivelFecharTela: true,
      fecharMenuProfile: false,
      loaderTrue: false,
      modoEdicao: "enviaremailativacao",
      registroLogin: getDefaultState(),
      vinculos: null,
      pensoes: [],
      pensaoSelecionada: null,
      registroVinculo: null,
      user: null,
      menu: [
        {
          label: "Tela Inicial",
          icon: "pi pi-fw pi-home",
          to: `/${process.env.VUE_APP_BASE_URL}`,
        },
      ],
      versaoAPI: this.$store.getters.getVersaoApi,
      versaoFRONT: "",
      tipoVinculo: "Contratado Temporário",
      podeDadosPessoais: false,
    };
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
    isLoader(newLoader) {
      this.loaderTrue = newLoader;
    },
    isversaoAPI(newVersaoApi) {
      this.versaoAPI = newVersaoApi;
    },
    isExisteUser(novaresposta, antigaResposta) {
      if (novaresposta != antigaResposta && novaresposta) {
        this.criarMenu();
      } else {
        this.menu = [
          {
            label: "Tela Inicial",
            icon: "pi pi-fw pi-home",
            to: "/" + process.env.VUE_APP_BASE_URL,
          },
        ];
      }
    },
  },
  methods: {
    cienteOnClick(detail) {
      this.$http.post(
        `${baseApiUrl}/acumuloFerias/notificacao`,
        JSON.stringify(detail)
      );
      this.$toast.removeGroup("tr");
    },
    verificaNotificacoes() {
      if (this.$store.getters.getMatricula) {
        return;
      }
      this.$http
        .get(
          `${baseApiUrl}/acumuloFerias/notificacao/${this.$store.getters.getMatricula}/${this.$store.getters.getVinculo}`
        )
        .then((res) => {
          res.data.forEach((element) => {
            this.$toast.add({
              severity: "info",
              summary: "Notificação:",
              detail: element,
              group: "tr",
            });
          });
        });
    },
    criarMenu() {
      this.menu = [
        {
          label: "Tela Inicial",
          icon: "pi pi-fw pi-home",
          to: "/" + process.env.VUE_APP_BASE_URL,
        },
      ];
      this.menu.push({
        label: "Serviços",
        icon: "pi pi-fw pi-briefcase",
        items: [],
      });
      if (this.isUserTemPerssao("holerite")) {
        this.menu[1].items.push({
          label: "Holerite",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/holerite",
        });
      }
      if (this.isUserTemPerssao("cedulac")) {
        this.menu[1].items.push({
          label: "Cédula C",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/cedulac",
        });
      }
      if (this.isUserTemPerssao("fichafinanceira")) {
        this.menu[1].items.push({
          label: "Fichas Financeiras",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/fichafinanceira",
        });
      }

      if (this.isUserTemPerssao("dadosPessoaisServidor")) {
        this.menu[1].items.push({
          label: "Dados Pessoais",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/servidor/dadosPessoais",
        });
      }

      if (this.isUserTemPerssao("retratoFuncional")) {
        this.menu[1].items.push({
          label: "Retrato Funcional",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/retratoFuncional",
        });
      }
      if (
        this.isUserTemPerssao("contribuicaoPrevidenciaria") &&
        this.tipoVinculo != "Contratado Temporário"
      ) {
        this.menu[1].items.push({
          label: "Extrato Previdenciário",
          icon: "pi pi-fw pi-table",
          to:
            "/" + process.env.VUE_APP_BASE_URL + "/contribuicaoPrevidenciaria",
        });
      }
      if (this.isUserTemPerssao("feriasServidor")) {
        this.menu[1].items.push({
          label: "Férias",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/ferias/servidor",
        });
      }
      if (this.isUserTemPerssao("licencaPremioServidor")) {
        this.menu[1].items.push({
          label: "Licença Prêmio",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/licencapremio/servidor",
        });
      }
      if (this.isUserTemPerssao("certidoes")) {
        this.menu[1].items.push({
          label: "Certidões",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/certidoes",
        });
      }

      // if (process.env.VUE_APP_AMBIENTE != "PRODUCAO"){
      //     if(this.isUserTemPerssao('avaliacao')){
      //         this.menu[1].items.push( {label: 'Avaliações', icon: 'pi pi-fw pi-list', to: '/'+process.env.VUE_APP_BASE_URL+'/avaliacao'})
      //     }
      // }

      // if(this.isUserTemPerssao('declaracaobens')){
      //     this.menu[1].items.push( {label: 'Bens e Valores', icon: 'pi pi-fw pi-table', to: '/'+process.env.VUE_APP_BASE_URL+'/declaracaobens'})
      // }
      // if(this.isUserTemPerssao('recadastramento')){
      //     this.menu[1].items.push( {label: 'Recadastramento', icon: 'pi pi-fw pi-table', to: '/'+process.env.VUE_APP_BASE_URL+'/recadastramento'})
      // }
      // if(this.isUserTemPerssao('sga')){
      //     this.menu[1].items.push( {label: 'Perícia Médica',icon: 'pi pi-fw pi-table',command: () => window.open('https://agendamentopericias.seplag.mt.gov.br', '_blank')});
      // }
      // if(this.isUserTemPerssao('carteiraFuncional')){
      //     this.menu[1].items.push( {label: 'Carteira Funcional Digital',icon: 'pi pi-fw pi-table', command: this.handleCarteiraFuncional});
      // }
      // if(this.isUserTemPerssao('cat')){
      //     this.menu[1].items.push( {label: 'CAT', icon: 'pi pi-fw pi-table', to: '/'+process.env.VUE_APP_BASE_URL+'/cat'});
      // }

      if (
        this.isUserTemPerssao("feriasChefiaPendenteValidacao") ||
        this.isUserTemPerssao("ChefiaPendentesLicenca")
      ) {
        let menuChefia = [];
        if (this.isUserTemPerssao("feriasChefiaPendenteValidacao")) {
          menuChefia.push({
            label: "Validação Férias",
            icon: "pi pi-fw pi-briefcase",
            to: "/" + process.env.VUE_APP_BASE_URL + "/ferias/chefia",
          });
        }
        if (this.isUserTemPerssao("ChefiaPendentesLicenca")) {
          menuChefia.push({
            label: "Validação Licença",
            icon: "pi pi-fw pi-briefcase",
            to:
              "/" + process.env.VUE_APP_BASE_URL + "/chefia/licenca/pendentes",
          });
        }
        this.menu.push({
          label: "Chefia",
          icon: "pi pi-fw pi-briefcase",
          items: menuChefia,
        });
      }
      if (this.isUserTemPerssao("cadEscala")) {
        this.menu.push({
          label: "Gestão de Escala",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/cadEscala",
        });
      }
      if (this.isUserTemPerssao("gestaoferias")) {
        this.menu.push({
          label: "Gestão de Férias",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/gestaoferias",
        });
      }
      if (this.isUserTemPerssao("gestaoLicencaPremio")) {
        this.menu.push({
          label: "Gestão de Licenca Premio",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/gestaoLicencaPremio",
        });
      }
      if (this.isUserTemPerssao("gestaoLPComissionado")) {
        this.menu.push({
          label: "Gestão de LP Comissionado",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/gestaoLPComissionado",
        });
      }
      if (this.isUserTemPerssao("liberacaoFerias")) {
        this.menu.push({
          label: "Liberação de Férias e LP",
          icon: "pi pi-fw pi-table",
          to: "/" + process.env.VUE_APP_BASE_URL + "/liberacaoFerias",
        });
      }
      if (this.isUserTemPerssao("orgaoVinculado")) {
        this.menu.push({
          label: "Órgão Vinculado",
          icon: "pi pi-fw pi-align-justify ",
          to: "/" + process.env.VUE_APP_BASE_URL + "/orgaoVinculado",
        });
      }
      if (this.isUserTemPerssao("cadastroUsuario")) {
        this.menu.push({
          label: "Perfil Usuários",
          icon: "pi pi-fw pi-user-edit",
          to:
            "/" + process.env.VUE_APP_BASE_URL + "/seguranca/cadastro/usuario",
        });
      }

      if (this.isUserTemPerssao("controlePerfilChefia")) {
        this.menu.push({
          label: "Controle Perfil Chefia",
          iconComponent: "AccountGroup",
          to: "/" + process.env.VUE_APP_BASE_URL + "/controlePerfilChefia",
        });
      }

      if (this.isUserTemPerssao("datalimitesocilicitacaoafastamento")) {
        this.menu.push({
          label: "Controle Data Limite",
          icon: "pi pi-fw pi-calendar",
          to:
            "/" +
            process.env.VUE_APP_BASE_URL +
            "/datalimitesocilicitacaoafastamento",
        });
      }
      if (this.isUserTemPerssao("cronogramaFerias")) {
        this.menu.push({
          label: "Cronograma de Férias",
          icon: "pi pi-fw pi-sun",
          to: "/" + process.env.VUE_APP_BASE_URL + "/cronogramaFerias",
        });
      }

      if (this.isUserTemPerssao("solicitaVerbaAdmin")) {
        let menuVerba = [];
        if (this.isUserTemPerssao("solicitaVerbaProcurador")) {
          menuVerba.push({
            label: "Liberação Verba Recisória",
            icon: "pi pi-fw pi-dollar",
            to:
              "/" +
              process.env.VUE_APP_BASE_URL +
              "/idenizacao/umTercoFerias/validador",
          });
        }
        if (this.isUserTemPerssao("indiceCalculo")) {
          menuVerba.push({
            label: "Gestão Indice Calculo",
            icon: "pi pi-fw pi-tags",
            to: "/" + process.env.VUE_APP_BASE_URL + "/idicecalculojurus",
          });
        }
        if (this.isUserTemPerssao("parametroSolicitacao")) {
          menuVerba.push({
            label: "Gestão Parâmetros",
            icon: "pi pi-fw pi-tags",
            to: "/" + process.env.VUE_APP_BASE_URL + "/idenizacao/parametro",
          });
        }
        this.menu.push({
          label: "Gestão Verba Recisória",
          icon: "pi pi-fw pi-dollar",
          items: menuVerba,
        });
      }

      if (
        this.isUserTemPerssao("manterDRE") ||
        this.isUserTemPerssao("vincularEscolas")
      ) {
        let menuDREs = [];
        if (this.isUserTemPerssao("manterDRE")) {
          menuDREs.push({
            label: "Manter DREs",
            icon: "pi pi-fw pi-book",
            to: "/" + process.env.VUE_APP_BASE_URL + "/dre/manter-dre",
          });
        }
        if (this.isUserTemPerssao("vincularEscolas")) {
          menuDREs.push({
            label: "Vincular Escolas",
            icon: "pi pi-fw pi-link",
            to: "/" + process.env.VUE_APP_BASE_URL + "/dre/vincular-escolas",
          });
        }
        this.menu.push({
          label: "DREs",
          icon: "pi pi-fw pi-building",
          items: menuDREs,
        });
      }

      // if(this.isUserTemPerssao('cadastroPerfilUsuario')){
      //     this.menu.push({label: 'Perfil', icon: 'pi pi-fw pi-tags', to: '/'+process.env.VUE_APP_BASE_URL+'/seguranca/cadastro/perfil'})
      // }

      if (process.env.VUE_APP_AMBIENTE == "HOMOLOG") {
        if (this.isUserTemPerssao("gerenciaRelatorios")) {
          this.menu.push({
            label: "Relatórios",
            icon: "pi pi-fw pi-chart-line",
            to: "/" + process.env.VUE_APP_BASE_URL + "/relatorio",
          });
        }
      }

      if (this.$store.getters.getUser.contaAcesso.trocarSenha == "S") {
        this.registroLogin = getDefaultState();
        this.visivelFecharTela = false;
        this.exibirTelaTrocarSenha = true;
      }
      if (this.isUserTemPerssao("dadosPessoaisServidor")) {
        this.podeDadosPessoais = true;
      }

      this.verificaNotificacoes();
    },

    handleCarteiraFuncional() {
      let nroVinculoSelecionado = this.$store.getters.getVinculo;
      let listaVinculos =
        this.$store.getters.getUser.dadosUsuariosCustomizados.listaVinculos;
      let vinculoSelecionado = listaVinculos.filter(function (element) {
        return element.vinculo == nroVinculoSelecionado;
      });
      this.$http
        .get(
          `${baseApiUrlCracha}/cfd/gerar/${vinculoSelecionado[0].matricula}/${vinculoSelecionado[0].vinculo}`
        )
        .then((res) => {
          this.pdfElement = res.data.dadosRelatorioBase64;
          this.nomeDocumentoPDF = res.data.nomeArquivo;
          this.exibirPDF = true;

          const byteCharacters = atob(res.data.dadosRelatorioBase64);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, "carteirafuncional.pdf");
          } else {
            const objectUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = "carteirafuncional.pdf";
            link.style.display = "none";

            if (this.detectaNavegador() === 4) {
              this.exibirPDF = false;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              setTimeout(() => {
                window.open(objectUrl, "_blank");
              }, 1000);
            }

            setTimeout(() => {
              URL.revokeObjectURL(objectUrl);
            }, 2000);
          }
        });
    },

    validateToken() {
      this.versaoFRONT = process.env.VUE_APP_VERSAO;
      var dataToken = null;
      if (localStorage.getItem(process.env.VUE_APP_USER_KEY)) {
        let dadosStorageSeplagJson = decodeURI(
          atob(localStorage.getItem(process.env.VUE_APP_USER_KEY))
        );
        dataToken = JSON.parse(dadosStorageSeplagJson);
      }

      if (dataToken) {
        if (!this.$store.getters.isUserLogado) {
          this.$store.commit("setUserLogado", true);
        }

        if (!this.$store.getters.getToken) {
          this.$store.commit("setToken", JSON.stringify(dataToken.token));
        }

        if (!this.$store.getters.getUser) {
          this.$store.dispatch("buscarUsuario", this);
        }
      }
    },
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          this.overlayMenuActive = !this.overlayMenuActive;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    atualizarSenha() {
      // this.registroLogin.id = this.$store.getters.getUser.contaAcesso.id
      this.registroLogin.login = this.$store.getters.getUser.contaAcesso.login;
      this.$http
        .put(
          `${baseApiUrl}/seguranca/contasacesso/senha/${this.$store.getters.getUser.contaAcesso.id}`,
          JSON.stringify(this.registroLogin)
        )
        .then((res) => {
          this.$toast.add({
            severity: "success",
            summary: res.data,
            life: 3000,
          });
          this.$store.dispatch("buscarUsuario", this);
          this.exibirTelaTrocarSenha = false;
          this.$store.commit("setExpandedProfile", false);
        })
        .catch((error) => {
          for (let i = 0; i < error.response.data.length; i++) {
            this.$toast.add({
              severity: "error",
              summary: error.response.data[i].msgUsuario,
              life: 3000,
            });
          }
        });
    },
    trocarSenha() {
      this.exibirTelaTrocarSenha = true;
      this.exibirTelaTrocaVinculo = false;
      this.visivelFecharTela = true;
      this.registroLogin = getDefaultState();
    },
    asUser() {
      if (
        this.$store.getters.getUser &&
        this.$store.getters.getUser.trocarSenha == "S"
      ) {
        this.exibirTela = true;
        this.visivelFecharTela = false;
        this.registroLogin = getDefaultState();
        this.registroLogin.id = this.$store.getters.getUser.id;
        this.registroLogin.login = this.$store.getters.getUser.login;
      }
    },
    atualizarPensao() {
      let novoUSer = {
        ...this.$store.getters.getUser.dadosUsuariosCustomizados,
        pensionista: this.pensaoSelecionada,
      };
      this.$store.commit("setUser", {
        ...this.$store.getters.getUser,
        dadosUsuariosCustomizados: novoUSer,
      });
      this.exibirTelaTrocaPensao = false;
      this.$store.commit("setExpandedProfile", false);
      if (this.$route.name !== "dashboard") {
        this.$router.push({ name: "dashboard" });
      }
    },
    atualizarVinculo() {
      let formData = new FormData();
      formData.append("vinculoSelecionado", this.registroVinculo.idenVinculo);
      formData.append("grant_type", "refresh_token");
      this.$http
        .post(`${baseApiUrl}/oauth/token`, formData, {
          withCredentials: true,
          headers: {
            "Content-Type":
              "application/x-www-form-urlencoded; charset=ISO-8859-1",
            Authorization: "Basic YW5ndWxhcjpAbmd1bEByMA==",
          },
        })
        .then((res) => {
          let token = JSON.parse(
            decodeURI(atob(localStorage.getItem(process.env.VUE_APP_USER_KEY)))
          );
          token.token = JSON.stringify(res.data);
          token[process.env.VUE_APP_NOME_SISTEMA] = {};
          localStorage.setItem(
            process.env.VUE_APP_USER_KEY,
            btoa(JSON.stringify(token))
          );
          localStorage.setItem("tk", JSON.stringify(JSON.stringify(token)));
          this.$store.commit("setToken", JSON.stringify(res.data));
          this.$store.dispatch("buscarUsuario", this).then(() => {
            this.criarMenu();
            this.$toast.add({
              severity: "success",
              summary: "Vínculo alterado com sucesso!",
              life: 3000,
            });
            this.exibirTelaTrocaVinculo = false;
            this.$store.commit("setExpandedProfile", false);
          });
          if (this.$route.name !== "dashboard") {
            this.$router.push({ name: "dashboard" });
          }
        });
    },
    trocarPensao() {
      this.exibirTelaTrocarSenha = false;
      this.exibirTelaTrocaVinculo = false;
      this.exibirTelaTrocaPensao = true;
      (this.visivelFecharTela = true), (this.fecharMenuProfile = false);
      this.pensoes =
        this.$store.getters.getUser.dadosUsuariosCustomizados.listaPensionista.filter(
          (elemet) => {
            return (
              elemet.vinculoServidor ==
              this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoSeap
                .vinculo
            );
          }
        );
      this.pensaoSelecionada =
        this.$store.getters.getUser.dadosUsuariosCustomizados.pensionista;
    },
    trocarVinculo() {
      this.exibirTelaTrocarSenha = false;
      this.exibirTelaTrocaVinculo = true;
      (this.visivelFecharTela = true), (this.fecharMenuProfile = false);
      this.vinculos = this.$store.getters.getUser.contaAcesso.listaVinculo;
      this.registroVinculo =
        this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoERP;
    },
    interageLoder(loader) {
      this.loaderTrue = loader;
    },
    beforeUpdate() {
      if (this.mobileMenuActive)
        this.addClass(document.body, "body-overflow-hidden");
      else this.removeClass(document.body, "body-overflow-hidden");
    },
    isUserTemPerssao(nomerota) {
      return isUserTemPerssaoGlobal(nomerota);
    },
  },
  created() {
    this.validateToken();
    this.tipoVinculo =
      this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoSeap.tipoVinculo;
  },
  computed: {
    ...mapGetters(["isUserLogado"]),
    containerClass() {
      if (!this.isUserLogado) {
        return [
          "layout-wrapper",
          {
            "layout-overlay": this.layoutMode === "overlay",
            "layout-static": this.layoutMode === "static",
            "layout-static-sidebar-inactive": true,
            "layout-overlay-sidebar-active":
              this.overlayMenuActive && this.layoutMode === "overlay",
            "layout-mobile-sidebar-active": this.mobileMenuActive,
          },
        ];
      } else {
        return [
          "layout-wrapper",
          {
            "layout-overlay": this.layoutMode === "overlay",
            "layout-static": this.layoutMode === "static",
            "layout-static-sidebar-inactive":
              this.staticMenuInactive && this.layoutMode === "static",
            "layout-overlay-sidebar-active":
              this.overlayMenuActive && this.layoutMode === "overlay",
            "layout-mobile-sidebar-active": this.mobileMenuActive,
          },
        ];
      }
    },
    sidebarClass() {
      return [
        "layout-sidebar",
        {
          "layout-sidebar-dark": this.layoutColorMode === "dark",
          "layout-sidebar-light": this.layoutColorMode === "light",
        },
      ];
    },
    logo() {
      //return (this.layoutColorMode === 'dark') ? "assets/layout/images/logo-white.svg" : "assets/layout/images/logo.svg";
      return "assets/seplag.png";
    },
    isLoader() {
      return this.$store.getters.isloader;
    },
    isversaoAPI() {
      return this.$store.getters.getVersaoApi;
    },
    isExisteUser() {
      return this.$store.getters.getUser ? true : false;
    },
  },
  components: {
    AppTopBar: AppTopBar,
    AppProfile: AppProfile,
    AppMenu: AppMenu,
    AppFooter: AppFooter,
    Login: Login,
    Loader: Loader,
    Rotulo,
    CadastroRapido,
  },
};
</script>

<style lang="scss">
@import "./App.scss";

.toast-summary {
  text-align: center;
  width: 100%;
}
</style>
